import { useTranslation } from 'react-i18next';

import { Button, DialogActions } from '@mui/material';

interface Params {
  onDialogClose: () => void;
}

const Actions = ({ onDialogClose }: Params) => {
  const { t } = useTranslation('common');

  return (
    <DialogActions>
      <Button onClick={onDialogClose} color="primary" variant="outlined">
        {t('cancel')}
      </Button>
      <Button type="submit" variant="contained" color="primary">
        {t('save')}
      </Button>
    </DialogActions>
  );
};

export default Actions;
